export default {
  guests_pay: 'Guests pay {{amount}} at checkout (latest exchange rate).',
  missing_rate: 'No exchange rate for {{currency}} yet, so guests pay {{amount}} unconverted.',
};
